import { Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import batteryOff from "../../../../../assets/img/Battery-off-transparent.png";
import batteryOn from "../../../../../assets/img/Battery-on-transparent.png";
import {
  DeviceConnectedLogo,
  DeviceDisconnectedLogo,
} from "../../../../Logo/logos";

const GasDevice = ({
  title,
  deviceId,
  deviceStatus,
  ch4Value,
  co2Value,
  o2Value,
  h2sValue,
  dewPointValue,
  gcvValue,
  ncvValue,
  n2Value,
  lastUpdated,
  powerStatus,
}) => {
  const isExpiredSubscription = ch4Value === "Subscription Expired";

  const display = (v) => {
    if (v === null || v === undefined) return "0";
    if (typeof v === "string" && (v.trim() === "" || v === "--")) return "0";
    const n = typeof v === "number" ? v : parseFloat(v);
    if (!Number.isNaN(n) && n < 0) return "0";
    return v;
  };
  const displayDew = (v) => {
    if (v === null || v === undefined) return "--";
    if (typeof v === "string" && v.trim() === "") return "--";
    const n = typeof v === "number" ? v : parseFloat(v);
    if (!Number.isNaN(n) && n < 0) return "0";
    return v;
  };

  return (
    <div
      style={{
        width: 350,
        height: 300,
        backgroundImage:
          deviceStatus === "active"
            ? "url(/images/flow.gif)"
            : "url(/images/flow.png)",
      }}
      className="device-card-flow"
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Tooltip title={title || ""} placement="top">
          <Link to={`/device-detail/${deviceId}`} style={{ textDecoration: "none" }}>
            <div
              style={{
                fontSize: "1.6rem",
                color: "#1C5E85",
                maxWidth: "220px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                cursor: "pointer",
              }}
            >
              {title}
            </div>
          </Link>
        </Tooltip>
        <div style={{ display: "flex", gap: "10px", paddingLeft: 1 }}>
          <>
            {!isExpiredSubscription &&
              (deviceStatus === "active" ? (
                <Tooltip title="Device Connected">
                  <DeviceConnectedLogo />
                </Tooltip>
              ) : (
                <Tooltip title="Device Disconnected">
                  <DeviceDisconnectedLogo />
                </Tooltip>
              ))}
            {!isExpiredSubscription &&
              (powerStatus === 1 ? (
                <Tooltip title="Power On">
                  <img
                    src={batteryOn}
                    alt="power-on"
                    style={{ height: "40px" }}
                  />
                </Tooltip>
              ) : (
                <Tooltip title="Power Off">
                  <img
                    src={batteryOff}
                    alt="power-off"
                    style={{ height: "40px" }}
                  />
                </Tooltip>
              ))}
          </>
        </div>
      </div>

      {isExpiredSubscription ? (
        <div
          style={{
            fontSize: "1.5rem",
            color: "#ff4444",
            fontWeight: "bold",
            marginTop: "50px",
            textAlign: "center",
            width: "300px",
          }}
        >
          {ch4Value}
        </div>
      ) : (
        <>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: 10,
              marginTop: 10,
            }}
          >
            <div>
              <div style={{ fontSize: "0.9rem" }}>CH4:</div>
              <div style={{ fontSize: "1.1rem", color: "#09c4ff" }}>
                {display(ch4Value)}
              </div>
            </div>
            <div>
              <div style={{ fontSize: "0.9rem" }}>CO2:</div>
              <div style={{ fontSize: "1.1rem", color: "#09c4ff" }}>
                {display(co2Value)}
              </div>
            </div>
            <div>
              <div style={{ fontSize: "0.9rem" }}>O2:</div>
              <div style={{ fontSize: "1.1rem", color: "#09c4ff" }}>
                {display(o2Value)}
              </div>
            </div>
            <div>
              <div style={{ fontSize: "0.9rem" }}>H2S:</div>
              <div style={{ fontSize: "1.1rem", color: "#09c4ff" }}>
                {display(h2sValue)}
              </div>
            </div>
            <div>
              <div style={{ fontSize: "0.9rem" }}>D-Point:</div>
              <div style={{ fontSize: "1.1rem", color: "#09c4ff" }}>
                {displayDew(dewPointValue)}
              </div>
            </div>
            <div>
              <div style={{ fontSize: "0.9rem" }}>GCV:</div>
              <div style={{ fontSize: "1.1rem", color: "#09c4ff" }}>
                {display(gcvValue)}
              </div>
            </div>
            <div>
              <div style={{ fontSize: "0.9rem" }}>NCV:</div>
              <div style={{ fontSize: "1.1rem", color: "#09c4ff" }}>
                {display(ncvValue)}
              </div>
            </div>
            <div>
              <div style={{ fontSize: "0.9rem" }}>N2:</div>
              <div style={{ fontSize: "1.1rem", color: "#09c4ff" }}>
                {display(n2Value)}
              </div>
            </div>
          </div>

          <div style={{ marginTop: 10 }}>
            <div style={{ fontSize: "0.9rem" }}>Last Updated:</div>
            <div style={{ fontSize: "1.1rem", color: "#09c4ff" }}>
              {lastUpdated}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default GasDevice;
